import styled from 'styled-components/macro';

import {useState} from "react";
import {
    Button,
    Checkbox,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import {useModal, useSettings} from "../store";
import useToggle from "../utils/use_toggle";
import {useFeedback} from "../store/feedback";
import {useSignUp} from "../api/sign_up";
// eslint-disable-next-line import/no-cycle
import Login from "./login";
import Onboarding from "./onboarding";
import {useBaseCommunity} from "../store/hooks";

const Signup = styled(({className, onClose}) => {
    const modal = useModal();
    const [login, setLogin] = useState({
        username: '',
        password: '',
    });
    const set = (name) => (value) => setLogin((login) => ({...login, [name]: value}));
    const [passwordVisibility, togglePasswordVisibility] = useToggle(false);
    const handleLogin = () => {
        modal.open(Login);
    };
    const {feedbackCh, error} = useFeedback();
    const signUp = useSignUp(feedbackCh);
    const [processing, setProcessing] = useState(false);
    const {theme, subscribed} = useSettings();
    const ref = localStorage.getItem('referrer');
    const baseCommunity = useBaseCommunity();
    const handleSignup = async () => {
        setProcessing(true);
        try {
            const result = await signUp({
                name: login.username,
                email: '',
                password: login.password,
                confirmPassword: login.password,
                com: window.origin,
                community: "Win",
                legal: true,
                subscriptions: [],
                theme,
                affRef: ref || "",
            });
            if (baseCommunity !== "TheDonald") {
                modal.open(Onboarding);
            }
            onClose();
        } catch {
            // error will be displayed
        }
        setProcessing(false);
    }
    const handleKeyPress = async (event) => {
        if (event.key === 'Enter'){
            await handleSignup();
        }
    }

    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                    <ModalHeader>Sign Up</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>Username</FormLabel>
                            <Input placeholder="" value={login.username} onKeyDown={handleKeyPress}
                                   onChange={(e) => set('username')(e.currentTarget.value)}/>
                            <FormHelperText>This will be public.</FormHelperText>
                        </FormControl>

                        <FormControl mt={4}>
                            <FormLabel>Password</FormLabel>
                            <Input placeholder="********" value={login.password} type={'password'} onKeyDown={handleKeyPress}
                                   onChange={(e) => set('password')(e.currentTarget.value)}/>
                            <FormHelperText>Passwords should be at least 8 characters.</FormHelperText>
                        </FormControl>

                        <FormControl isInvalid={error}>
                            <FormErrorMessage>{error?.toString()}</FormErrorMessage>
                        </FormControl>

                        <FormControl style={{marginTop: 12}}>
                            <Checkbox size={'sm'}>I agree to the Terms of Service and Privacy Policy.</Checkbox>
                        </FormControl>

                    </ModalBody>

                    <ModalFooter>

                        <Button variant="cancel" mr={3} onClick={handleLogin}>Login</Button>
                        <Button type='submit' variant="blue" isLoading={processing} onClick={handleSignup}>
                            Sign Up
                        </Button>
                    </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
`;

export default Signup;
